// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__QdetY","link":"Footer_link__3XBKE","content":"Footer_content__RKdPg"};